import { render, staticRenderFns } from "./LocalisationResidence.vue?vue&type=template&id=8a0e2552&"
import script from "./LocalisationResidence.vue?vue&type=script&lang=js&"
export * from "./LocalisationResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports